// notificationSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationState } from "./types";
import { INITINAL_STATE } from "./constant";

const notificationSlice = createSlice({
  name: "notification",
  initialState: INITINAL_STATE,
  reducers: {
    showNotification: (
      state,
      action: PayloadAction<Omit<NotificationState, "visible">>
    ) => {
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.visible = true;
    },

    hideNotification: (state) => {
      state.visible = false;
    },
  },
});

export const { showNotification, hideNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
